import { Component, OnInit } from '@angular/core';
import { UsuarioBc } from '../../model/usuario-bc';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../services/storage.service';
import { Estabelecimento } from '../../model/estabelecimento';
import { Solicitacao } from '../../model/solicitacao';
import { RespostaUsuarioCns } from '../../model/usuario-cns';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SolicitacoesService } from '../../services/solicitacoes.service';
import * as _ from 'underscore';
import { OperacaoSolicitada, ServicoSolicitado } from '../../model/solicitacao-pni';
import { SistemasService } from '../../services/sistemas.service';
import { cnpj, cns, cpf, cep } from "../../util/format";
import { MESES } from "../../util/format";
import * as moment from 'moment';

@Component({
  selector: 'app-termos-de-uso',
  templateUrl: './termos-de-uso.component.html',
  styleUrls: ['./termos-de-uso.component.scss'],
})
export class TermosDeUsoComponent implements OnInit {

  usuarioLogado: UsuarioBc;
  config: any;
  carregando = true;
  currentApp: any;
  aceitou = false;
  showModalSucesso: any;
  estabelecimento: Estabelecimento = new Estabelecimento();
  solicitacao: Solicitacao = new Solicitacao();
  solicitacaoSend: any = new Solicitacao();
  responsavel: RespostaUsuarioCns = new RespostaUsuarioCns();
  filhos: boolean;
  esus: boolean;
  sistemas: boolean;
  servicosTodos: any;
  servicosBkp: any;
  user: any;
  termo: any;
  disable = false;
  cnpj = cnpj;
  cns = cns;
  cpf = cpf;
  cep = cep;
  dia: string;
  mes: string;
  ano: string;
  nomeCessionario: string;
  cnpjCessionario: string;
  enderecoCessionario: string;
  cepCessionario: string;
  nomeGestor: string;
  cpfGestor: string;
  emailGestor: string;
  telefoneGestor: string;
  hoje: string;
  nomeRepresentanteCessionario: string;
  cpfRepresentanteCessionario: string;
  telefoneRepresentanteCessionario: string;
  emailRepresentanteCessionario: string;

  constructor(
    private authService: AuthService,
    private toast: ToastrService,
    private storage: StorageService,
    private router: Router,
    private loading: NgxSpinnerService,
    private solicitacaoSv: SolicitacoesService,
    private sistemasService: SistemasService
  ) {
    this.currentApp = JSON.parse(this.storage.getCurrentApp());
    this.user = this.storage.getUserBc();
    this.loadCurrent();
  }

  loadCurrent() {
    const solicitacao = localStorage.getItem('current-solicitacao');
    const estabelecimento = localStorage.getItem('current-estabelecimento');
    const responsavel = localStorage.getItem('current-responsavel');
    const filhos = localStorage.getItem('filhos');
    const esus = localStorage.getItem('esus');
    const sistemas = localStorage.getItem('sistemas');
    const servicosTodos = localStorage.getItem('servicosPortfolio');


    if (solicitacao) {
      const item = JSON.parse(solicitacao);
      this.solicitacao = item;
      this.solicitacaoSend = item;
      this.clear();
      this.estabelecimento = JSON.parse(estabelecimento);
      this.responsavel = JSON.parse(responsavel);
      this.filhos = JSON.parse(filhos);
      this.esus = JSON.parse(esus);
      this.sistemas = JSON.parse(sistemas);
      this.servicosTodos = JSON.parse(servicosTodos);
      this.loadTerm();
    }
  }

  async loadTerm() {
    this.config = this.currentApp;
    this.termo = await this.sistemasService.getTerm(this.config.objectId);
    const date = new Date();
    this.dia = date.getDate().toString();
    this.mes = MESES[date.getMonth()];
    this.ano = date.getFullYear().toString();
    this.hoje = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: 'long', day: '2-digit' }).format(date);
    this.nomeCessionario = this.estabelecimento.nomeEmpresarial;
    this.cnpjCessionario = this.estabelecimento.numeroCNPJ;
    this.enderecoCessionario = this.estabelecimento.descricaoEndereco;
    this.cepCessionario = this.estabelecimento.cep;
    this.nomeGestor = this.responsavel.usuarioSUS.nome;
    this.cpfGestor = this.responsavel.usuarioSUS.numeroCPF;
    this.emailGestor = this.responsavel.usuarioSUS.email;
    this.telefoneGestor = this.responsavel.usuarioSUS.numTelefone.toString();
    this.termo = this.termo.replace('{{dia}}', this.dia);
    this.termo = this.termo.replace('{{mes}}', this.mes);
    this.termo = this.termo.replace('{{ano}}', this.ano);
    this.termo = this.termo.replace('{{hoje}}', this.hoje);
    this.termo = this.termo.replace('{{nomeCessionario}}', this.nomeCessionario);
    this.termo = this.termo.replace('{{nomeCessionario}}', this.nomeCessionario);
    this.termo = this.termo.replace('{{nomeCessionario}}', this.nomeCessionario);
    this.termo = this.termo.replace('{{cnpjCessionario}}', this.cnpj(this.cnpjCessionario));
    this.termo = this.termo.replace('{{enderecoCessionario}}', this.enderecoCessionario);
    this.termo = this.termo.replace('{{cepCessionario}}', this.cep(this.cepCessionario));
    this.termo = this.termo.replace('{{nomeGestor}}', this.nomeGestor);
    this.termo = this.termo.replace('{{cpfGestor}}', this.cpf(this.enderecoCessionario));
    this.termo = this.termo.replace('{{emailGestor}}', this.emailGestor);
    this.termo = this.termo.replace('{{telefoneGestor}}', this.telefoneGestor);
    if (this.responsavel.usuarioSUS) {
      this.nomeRepresentanteCessionario = this.responsavel.usuarioSUS.nome;
      this.cpfRepresentanteCessionario = this.responsavel.usuarioSUS.numeroCPF;
      this.telefoneRepresentanteCessionario = this.responsavel.usuarioSUS.numTelefone.toString();
      this.emailRepresentanteCessionario = this.responsavel.usuarioSUS.email;
      this.termo = this.termo.replace('{{nomeRepresentanteCessionario}}', this.nomeRepresentanteCessionario);
      this.termo = this.termo.replace('{{nomeRepresentanteCessionario}}', this.nomeRepresentanteCessionario);
      this.termo = this.termo.replace('{{cpfRepresentanteCessionario}}', this.cpfRepresentanteCessionario);
      this.termo = this.termo.replace('{{telefoneRepresentanteCessionario}}', this.telefoneRepresentanteCessionario);
      this.termo = this.termo.replace('{{emailRepresentanteCessionario}}', this.emailRepresentanteCessionario);
    }
  }

  async ngOnInit() {
    this.toast.toastrConfig.enableHtml = true;
    try {
      this.config = this.currentApp;
      this.usuarioLogado = this.authService.getUsuarioLogado();
      this.carregando = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      this.toast.error('Ocorreu um erro.');
      this.carregando = false;
    }
  }

  fecharModalSucesso() {
    this.router.navigateByUrl('/solicitacoes');
  }

  goBack() {
    this.router.navigateByUrl('/resumo-solicitacao');
  }

  async next() {
    try {
      if (this.aceitou) {
        if (this.disable == false) {
          this.disable = true;
          this.loading.show();
          if ((this.config.sigla === 'RNDS' || this.config.sigla === 'SI-PNI' || this.config.sigla === 'CNS'
            || this.config.sigla === 'Vacinação') && this.config.portifolio != 8) {
            this.incluirTodasOperacoes();
          }
          const item = await this.solicitacaoSv.incluirSolicitacaoExterna(this.tratarSolicitacao(this.solicitacaoSend));
          if (!item || !item.sucesso || item.sucesso !== true) {
            this.loading.hide();
            item.mensagens.forEach((m) => {
              this.toast.error(m);
            });
            this.disable = false;
          } else {
            this.loading.show();
            await this.solicitacaoSv.enviarParaAprovacao({
              ano: item.nuAno,
              numero: item.nuSolicitacao
            });
            this.showModalSucesso = true;
            this.loading.hide();
            this.disable = false;
          }
        }
      } else {
        this.toast.error('Aceite os termos de uso para continuar');
        this.disable = false;
      }
    } catch (e) {
      this.disable = false;
      console.log(e);
    }
  }

  clear() {
    this.solicitacaoSend.noUsuario = this.user.cpf;
    delete this.solicitacaoSend.solicitante.dsComplemento;
    if (this.solicitacaoSend.sistema.stEmpresaPrivada === 'O') {
      delete this.solicitacaoSend.sistema.stEmpresaPrivada;
    }
    // tslint:disable-next-line:radix
    this.solicitacaoSend.solicitante.nuDdd = parseInt(this.solicitacaoSend.solicitante.nuDdd);
    // tslint:disable-next-line:radix
    this.solicitacaoSend.solicitante.nuTelefone = parseInt(this.solicitacaoSend.solicitante.nuTelefone);
    this.solicitacaoSend.estabelecimentosFilhos = _.map(this.solicitacaoSend.estabelecimentosFilhos, (item: any) => {
      return {
        nuCnes: item.nuCnes,
        codigoMunicipio: (item.codigoMunicipio) ? item.codigoMunicipio : null,
        codigoUF: (item.codigoUF) ? item.codigoUF : null,
        siglaUf: (item.siglaUf) ? item.siglaUf : null
      };
    });

    this.solicitacaoSend.portfolioSolicitadoModel.servicos = _.map(this.solicitacaoSend.portfolioSolicitadoModel.servicos, (data: any) => {
      return {
        id: data.id,
        operacaoSolicitadas: _.map(data.operacaoSolicitadas, (dataOp: any) => {
          return {
            id: dataOp.id,
          };
        })
      };
    });
  }

  private tratarSolicitacao(solicitacao: Solicitacao) {
    this.solicitacaoSend.solicitante.nuCnpj = (this.solicitacaoSend.solicitante.nuCnpj || '').replace(/\D/g, '');
    this.solicitacaoSend.solicitante.cns = (this.responsavel.usuarioSUS.numeroCNS || '').replace(/\D/g, '');
    if (this.solicitacaoSend.sistema.operadorCadsus.hasOwnProperty('nuCpf')) {
      this.solicitacaoSend.sistema.operadorCadsus.nuCpf = (this.solicitacaoSend.sistema.operadorCadsus.nuCpf || '')
        .replace(/\D/g, '');
    }
    if (this.solicitacaoSend.sistema.operadorCadsus.hasOwnProperty('nuCns')) {
      this.solicitacaoSend.sistema.operadorCadsus.nuCns = (this.solicitacaoSend.sistema.operadorCadsus.nuCns || '')
        .toString().replace(/\D/g, '');
    }


    try {
      this.solicitacaoSend.portfolioSolicitadoModel.dtInicioPicoAcesso = moment(this.solicitacaoSend.portfolioSolicitadoModel.dtInicioPicoAcesso).utc().format('YYYY-MM-DD HH:mm');
    } catch (err) {

    }
    try {
      this.solicitacaoSend.portfolioSolicitadoModel.dtFimPicoAcesso = moment(this.solicitacaoSend.portfolioSolicitadoModel.dtFimPicoAcesso).utc().format('YYYY-MM-DD HH:mm');
    } catch (err) {

    }
    try {
      this.solicitacaoSend.credencialModel.dtInsercao = moment(this.solicitacaoSend.credencialModel.dtInsercao).utc().format('YYYY-MM-DD HH:mm');
    } catch (err) {

    }

    return this.solicitacaoSend;
  }

  private incluirTodasOperacoes() {
    this.servicosBkp = [...this.solicitacaoSend.portfolioSolicitadoModel.servicos];
    this.solicitacaoSend.portfolioSolicitadoModel.servicos =
      (this.servicosTodos.filter((servico) => servico.noServico.toLowerCase().indexOf('pix') < 0) || [])
        .map(servico => <ServicoSolicitado>{
          id: servico.id,
          operacaoSolicitadas: servico.operacoes.map(operacao => <OperacaoSolicitada>{ id: operacao.id })
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/termos-de-uso/termos-de-uso.component.ts